import React, { useState, useEffect, useCallback } from "react";
import Select from "react-select";
import api from "../../api/api";
import { useNavigate, useParams } from "react-router-dom";
import Attachments from "../../UserControls/Attachments/Attachments"

async function getPublicIP() {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch {
    return "0.0.0.0";
  }
}

const userName = sessionStorage.getItem("userName");
//const getTodayDate = () => new Date().toISOString().split("T")[0];

const getTodayDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const milliseconds = String(now.getMilliseconds()).padStart(3, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
};

const getInitialFormState = () => ({
  SqlAction: "INSERT",
  TicketNo: "",
  UserName: userName,
  UserId: 1,
  ShiftName: "",
  ShiftId: "",
  Asset: "",
  AssetId: "",
  FaultCodeandTitle: "",
  FaultId: "",
  Priority: "",
  PriorityId: "",
  IssueTitle: "",
  Reproduce: "",
  ReproduceId: "",
  Description: "",
  UserStatus: "Open",
  DeptName: "",
  DeptId: "",
  RaisedBy: "",
  Seviority: "",
  SeviorityId: "",
  AllotedTo: "",
  AllotedToId: "0",
  TicketOpenTime: getTodayDate(),
  BreakDownTime: getTodayDate(),
  TicketId: 0,
  ComId: "GRANT000000000000001",
  IpAddress: "127.0.0.1",
});

export default function TicketForm() {
  const { ticketId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(getInitialFormState());
  const [dropdownData, setDropdownData] = useState({
    shifts: [],
    assets: [],
    priorities: [],
    reproducibility: [],
    severities: [],
    users: [],
    departments: [],
    currentUser: "",
    nextTicketNo: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isEditMode = !!ticketId;

  const findByName = (array, nameKey, nameValue) =>
    array.find((i) => i[nameKey]?.toString().trim() === nameValue?.toString().trim());

  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const apiData = await api.GetTicketValues(userName);
      const userIP = await getPublicIP();

      const currentUser = apiData.Table7?.[0]?.UsrName || userName;
      const nextTicketNo = apiData.Table9?.[0]?.DocNo || "";

      const newDropdownData = {
        shifts: apiData.Table || [],
        assets: apiData.Table1 || [],
        priorities: apiData.Table3 || [],
        reproducibility: apiData.Table4 || [],
        severities: apiData.Table5 || [],
        users: apiData.Table6 || [],
        departments: apiData.Table8 || [],
        currentUser,
        nextTicketNo,
      };
      setDropdownData(newDropdownData);

      let ticketFormData = { ...getInitialFormState(), IpAddress: userIP };

      if (isEditMode) {
        const editData = await api.EditTicket(ticketId);
        const ticketData = editData.Table?.[0];
        if (!ticketData) throw new Error("Ticket data not found");

        // Find corresponding dropdown objects
        const shift = findByName(newDropdownData.shifts, "shiftName", ticketData.ShiftName);
        const asset = findByName(newDropdownData.assets, "AssetName", ticketData.AssetName);
        const priority = findByName(newDropdownData.priorities, "Tpriority", ticketData.Priority);
        const severity = findByName(newDropdownData.severities, "TSeverity", ticketData.Seviority);
        const reproduce = findByName(newDropdownData.reproducibility, "TReproducebility", ticketData.Reproduce);
        const user = findByName(newDropdownData.users, "UsrName", ticketData.AllotedTo);
        const dept = findByName(newDropdownData.departments, "Department", ticketData.DeptName);

        ticketFormData = {
          ...ticketFormData,
          ...ticketData,
          SqlAction: "UPDATE",
          IpAddress: userIP,
          TicketId: parseInt(ticketData.TicketId || ticketData.Ticketid) || 0,
          TicketOpenTime:
  ticketData.TicketOpenTime && !ticketData.TicketOpenTime.includes("00:00:00")
    ? ticketData.TicketOpenTime.replace("T", " ")
    : getTodayDate(),

BreakDownTime:
  ticketData.TicketCloseTime && !ticketData.TicketCloseTime.includes("00:00:00")
    ? ticketData.TicketCloseTime.replace("T", " ")
    : getTodayDate(),
          RaisedBy: ticketData.RaisedBy || currentUser,

          ShiftId: shift ? shift.shiftid : "",
          ShiftName: shift ? shift.ShiftName : ticketData.ShiftName,

          AssetId: asset ? asset.AssetId : "",
          Asset: asset ? asset.AssetName : ticketData.AssetName,

          PriorityId: priority ? priority.TpId : "",
          Priority: priority ? priority.Tpriority : ticketData.Priority,

          SeviorityId: severity ? severity.TsId : "",
          Seviority: severity ? severity.TSeverity : ticketData.Seviority,

          ReproduceId: reproduce ? reproduce.TRId : "",
          Reproduce: reproduce ? reproduce.TReproducebility : ticketData.Reproduce,

          AllotedToId: user ? user.UsrId : "",
          AllotedTo: user ? user.UsrName : ticketData.AllotedTo,

          DeptId: dept ? dept.DeptId : "",
          DeptName: dept ? dept.Department : ticketData.DeptName,
        };
      } else {
        ticketFormData.RaisedBy = currentUser;
        ticketFormData.TicketNo = nextTicketNo;
      }

      setFormData(ticketFormData);
    } catch (e) {
      setError(`Failed to load form data: ${e.message}`);
    } finally {
      setLoading(false);
    }
  }, [ticketId, isEditMode]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (idField, option, nameField) => {
    setFormData((prev) => ({
      ...prev,
      [idField]: option ? option.value : "",
      [nameField]: option ? option.label : "",
    }));
  };

  const mapOptions = (array, valueField, labelField) =>
    array.map((item) => ({
      value: String(item[valueField]),
      label: item[labelField],
    }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        ...formData,
        ShiftId: +formData.ShiftId || 0,
        AssetId: +formData.AssetId || 0,
        PriorityId: +formData.PriorityId || 0,
        ReproduceId: +formData.ReproduceId || 0,
        SeviorityId: +formData.SeviorityId || 0,
        DeptId: +formData.DeptId || 0,
        AllotedToId: +formData.AllotedToId || 0,
        TicketId: +formData.TicketId || 0,
      };

      await api.SaveTicket(payload);
      alert(`Ticket ${isEditMode ? "updated" : "created"} successfully!`);
      navigate("/TicketList");
    } catch (e) {
      alert(`Error saving ticket: ${e.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (loading && !dropdownData.assets.length)
    return <div className="loading-fullscreen">Loading form...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="ticket-system-container">
      <style>{cssStyles}</style>
      <form onSubmit={handleSubmit} className="ticket-form">
        <div className="form-header">
          <h2 className="form-title">
            {isEditMode ? "Edit Ticket" : "Raise New Ticket"}
          </h2>
          <button
            type="button"
            onClick={() => navigate("/TicketList")}
            className="btn btn-secondary"
          >
            &larr; Back
          </button>
        </div>

        <div className="form-grid">
          <div className="form-group">
            <label>Ticket No</label>
            <input type="text" name="TicketNo" value={formData.TicketNo} disabled />
          </div>

          <div className="form-group">
            <label>Raised By</label>
            <input type="text" name="RaisedBy" value={formData.RaisedBy} disabled />
          </div>

          <div className="form-group span-2">
            <label>Asset</label>
            <Select
              options={mapOptions(dropdownData.assets, "AssetId", "AssetName")}
              value={
                formData.AssetId
                  ? { value: String(formData.AssetId), label: formData.Asset }
                  : null
              }
              onChange={(opt) => handleSelectChange("AssetId", opt, "Asset")}
              isClearable
              placeholder="-- Select Asset --"
            />
          </div>

          <div className="form-group span-2">
            <label>Issue Title</label>
            <input
              type="text"
              name="IssueTitle"
              value={formData.IssueTitle}
              onChange={handleChange}
            />
          </div>

          <div className="form-group span-2">
            <label>Description</label>
            <textarea
              name="Description"
              value={formData.Description}
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="form-group">
            <label>Department</label>
            <Select
              options={mapOptions(dropdownData.departments, "DeptId", "Department")}
              value={
                formData.DeptId
                  ? { value: String(formData.DeptId), label: formData.DeptName }
                  : null
              }
              onChange={(opt) => handleSelectChange("DeptId", opt, "DeptName")}
              isClearable
              placeholder="-- Select Department --"
            />
          </div>

          <div className="form-group">
            <label>Shift</label>
            <Select
              options={mapOptions(dropdownData.shifts, "shiftid", "ShiftName")}
              value={
                formData.ShiftId
                  ? { value: String(formData.ShiftId), label: formData.ShiftName }
                  : null
              }
              onChange={(opt) => handleSelectChange("ShiftId", opt, "ShiftName")}
              isClearable
              placeholder="-- Select Shift --"
            />
          </div>

          <div className="form-group">
            <label>Priority</label>
            <Select
              options={mapOptions(dropdownData.priorities, "TpId", "Tpriority")}
              value={
                formData.PriorityId
                  ? { value: String(formData.PriorityId), label: formData.Priority }
                  : null
              }
              onChange={(opt) => handleSelectChange("PriorityId", opt, "Priority")}
              isClearable
              placeholder="-- Select Priority --"
            />
          </div>

          <div className="form-group">
            <label>Reproducibility</label>
            <Select
              options={mapOptions(dropdownData.reproducibility, "TRId", "TReproducebility")}
              value={
                formData.ReproduceId
                  ? { value: String(formData.ReproduceId), label: formData.Reproduce }
                  : null
              }
              onChange={(opt) => handleSelectChange("ReproduceId", opt, "Reproduce")}
              isClearable
              placeholder="-- Select Reproducibility --"
            />
          </div>

          <div className="form-group">
            <label>Severity</label>
            <Select
              options={mapOptions(dropdownData.severities, "TsId", "TSeverity")}
              value={
                formData.SeviorityId
                  ? { value: String(formData.SeviorityId), label: formData.Seviority }
                  : null
              }
              onChange={(opt) => handleSelectChange("SeviorityId", opt, "Seviority")}
              isClearable
              placeholder="-- Select Severity --"
            />
          </div>

         <div style={{ display: "none" }}>
            <label>Allotted To</label>
            <Select
              options={mapOptions(dropdownData.users, "UsrId", "UsrName")}
              value={
                formData.AllotedToId
                  ? { value: String(formData.AllotedToId), label: formData.AllotedTo }
                  : null
              }
              onChange={(opt) => handleSelectChange("AllotedToId", opt, "AllotedTo")}
              isClearable
              placeholder="-- Select User --"
              
            />
          </div>
           <div className="attachments-wrapper">
        <div
          onClick={(e) => e.stopPropagation()}
          onFocus={(e) => e.stopPropagation()}
          style={{ margin: "20px 0" }}
        >
    <Attachments
            mdlId="TicketForm"
            primeId={formData.TicketId || 0}
            primeName={formData.TicketNo || ""} 
            uploadedBy={sessionStorage.getItem("userName")}
          />

        </div>
    </div>
        </div>

        <div className="form-footer">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Saving..." : isEditMode ? "Update" : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
}

// 🎨 CSS
const cssStyles = `
.ticket-system-container {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f9fafc;
  padding: 30px;
  min-height: 100vh;
}
.ticket-form {
  background: #fff;
  padding: 30px 35px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  max-width: 900px;
  margin: 0 auto;
}
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #eaeaea;
  padding-bottom: 12px;
  margin-bottom: 25px;
}
.form-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
}
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
.form-group {
  display: flex;
  flex-direction: column;
}
.form-group.span-2 {
  grid-column: span 2;
}
.form-group label {
  margin-bottom: 6px;
  font-weight: 500;
  color: #555;
}
.form-group input,
.form-group textarea {
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.form-group input:focus,
.form-group textarea:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 0 3px rgba(0,123,255,0.15);
}
textarea {
  resize: vertical;
  min-height: 80px;
}
.btn-primary {
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
}
.btn-primary:hover { background: #0056b3; }
.btn-secondary {
  background: #007bff;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
}
.btn-secondary:hover { background: #007bff; }
.form-footer {
    display: flex;
    justify-content: flex-end; /* Aligns button to the right */
    margin-top: 20px;
    width: 100%;
}
    .form-footer .btn {
    min-width: 12px;
    text-align: center;
}

.error-message {
  padding: 15px;
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
  border-radius: 6px;
  margin: 15px auto;
  max-width: 700px;
}
    .attachments-wrapper button {
  padding: 6px 12px !important;
  font-size: 13px !important;
  border-radius: 6px !important;
  height: auto !important;
}
`;

